class FacetApplyButton extends HTMLButtonElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick.bind(this));

    const form = this.closest('facets-drawer');

    form.querySelectorAll('details input').forEach(opt => {
      opt.addEventListener('change', this.handleFacetSelection.bind(this))
    });
  }

  handleFacetSelection() {
    const drawer = this.closest('facets-drawer');
    const form = drawer?.querySelector('[is="facets-form"]');
    
   form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }
  
  handleClick() {
    const drawer = this.closest('facets-drawer');
    const form = drawer?.querySelector('[is="facets-form"]');
    
    if (!form || !this.hasActiveFilters(form)) return;
    
    this.applyFilters(form);
    this.handleDrawerClose(drawer);
  }
  
  hasActiveFilters(form) {
    const checkedBoxes = form.querySelectorAll('input[type="checkbox"]:checked');
    const priceInputs = Array.from(form.querySelectorAll('input[name^="filter.v.price"]'));
    const hasPriceFilter = priceInputs.some(input => input.value.trim());
    
    return checkedBoxes.length > 0 || hasPriceFilter;
  }
  
  applyFilters(form) {
    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }
  
  handleDrawerClose(drawer) {
    const isMobile = window.matchMedia('(max-width: 999px)').matches;
    
    if (isMobile) {
      drawer.dispatchEvent(new CustomEvent('dialog:force-close', { 
        bubbles: true, 
        cancelable: true, 
        composed: true 
      }));
    }
  }
}

if (!window.customElements.get('facet-apply-button')) {
  window.customElements.define('facet-apply-button', FacetApplyButton, { extends: 'button' });
}

document.addEventListener('click', function (event) {
  const link = event.target.closest('[data-filter-param][data-filter-value]');
  if (!link) return;

  event.preventDefault();

  const paramName = link.getAttribute('data-filter-param');
  const paramValue = link.getAttribute('data-filter-value');
  const section = link.closest('.shopify-section');
  if (!section) return;

  const url = new URL(window.location.href);
  url.searchParams.delete('page');
  const existing = url.searchParams.getAll(paramName);
  url.searchParams.delete(paramName);
  existing.filter(v => v !== paramValue).forEach(v => url.searchParams.append(paramName, v));
  url.searchParams.set('section_id', section.id.replace('shopify-section-', ''));

  document.dispatchEvent(new CustomEvent('facet:update', { detail: { url } }));
});
